import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

















export const BaseDialog = props => {
  const {
    children,
    isOpen,
    btnSubmitText = 'Submit',
    btnCloseText = 'Cancel',
    btnSubmitDisabled,
    title,
    handleClose,
    handleSubmit,
    isSending,
  } = props;

  return (
    React.createElement(Dialog, {
      fullWidth: true,
      open: isOpen,
      onClose: (event) => handleClose(event),}
    
      , React.createElement(DialogTitle, null, title)
      , React.createElement(DialogContent, null, children)
      , React.createElement(DialogActions, { style: { marginRight: 15, marginBottom: 10 },}
        , React.createElement(Button, {
          onClick: (event) => handleClose(event),
          color: "primary",
          variant: "outlined",
          disabled: isSending,}
        
          , btnCloseText
        )
        , handleSubmit && (
          React.createElement(Button, {
            disabled: btnSubmitDisabled,
            onClick: (event) => handleSubmit(event),
            color: "primary",
            variant: "contained",
            endIcon: isSending && React.createElement(CircularProgress, { size: 20,} ),}
          
            , btnSubmitText
          )
        )
      )
    )
  );
};
export default BaseDialog;
